import React from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { useState, useEffect } from "react";
function AcademicHeadMessage() {
  useEffect(() => {
    document.title = "Academic Head Message -  Gayatri International School";
  }, []);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const msgdata = await getPrincipalMessage();
        const data = msgdata.filter(
          (item) =>
            item.school === "FARRUKHABAD" && item.category === "Manager",
        );

        setData(data);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Header />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Academic Head's Message </h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/HomeFr"> Home</Link>
            </li>
            <li>|</li>
            <li> Academic Head's Message </li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            {data.length > 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`}
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt={data[0].name || "Image"}
                  />
                </LazyLoad>
                <p>
                  <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                </p>
                <p className="name">
                  {data[0].name}
                  <span> Academic Head </span>
                </p>
              </div>
            )}

            {data.length === 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/default.jpg"
                    className="img-fluid col-sm-12 col-md-3 float-md-end mb-3 msgimg"
                    alt=""
                  />
                </LazyLoad>
                <p>
                  <b>
                    "If You Are Planing For One Year, Sow Rice. If You Are
                    Planning For A Decade, Plant Trees. If You Are Planning For
                    A Lifetime, Educate People."
                  </b>
                </p>

                <p>
                  Gayatri International School, has been established with the
                  vision to be one of the leading school in the community we
                  serve, known and widely acknowledged as a provider of quality
                  education which develops character and ethical values.
                </p>
                <p>
                  GIS provides a platform where maximum exposure of various
                  skills sets like leadership, adaptability, time management
                  with scholistic and co-scholistic. Development take place in
                  an awe-inspiring environment as a academic head at GIS with
                  high experience of working in schools like G.D. Goenka,
                  Lucknow Public School, CMS and Chinmaya Mission, i truly
                  believe that investing in education and providing 21st century
                  skills to students are fundamental components to the country’s
                  growth and prosperity
                </p>
                <p>
                  We at Gayatri International School ensure high quality
                  education and make the student globally connected. We look
                  forward to welcoming you to be a part of our vibrant and
                  enthusiastic learning community.
                </p>
                <p>Best wishes </p>

                <p className="name">
                  Abha Patel <span> Academic Head </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default AcademicHeadMessage;
